// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3l6QP","notes":"Notes_notes__2GCSA"};